
export class Frictionless {
    public receipientEmailIds: string = '';
    public referralCode: string = '';
}
